
import {fire} from '@/firebase/config'
import { useStore } from "vuex";
import { onMounted, ref, provide } from "vue";
import { a, n } from "@/composables/types";
import useCss from "@/composables/useCss";
// import { useRouter, useRoute } from "vue-router";

export default {
  // components: [],
  setup() {
    const ss = useStore().state;

    const data = ref()
    fire.collection("fl_schemas").get()
      .then((res)=>{
        res.docs.forEach((doc)=>{
          // doc.data().fields
          const text = doc.data().fields[0].defaultValue;
          data.value = doc.data()
          console.log(text)
          return text
        })

      })

    console.log(`fire.collection("fl_schemas")`)
    // const router = useRouter();
    // const sg = useStore().getters;
    ///////////////////////

    ///////////css////////////
    // const { cqueA, cLenEqual } = useCss();
    //......................................
    //

    // onMounted(() => {
    // elements
    // action
    // });
    ////////////////////////
    return {
      ss, data
    };
  }
};
